/* eslint-disable no-underscore-dangle */
import store from '../store';
import roles from './roles';

let _router = {};
let _vue = {};

function checkAuth(allowedRoles) {
  const userRole = store.state.account.user?.userType;

  if (allowedRoles.length === 0 && userRole) {
    return true;
  }

  return allowedRoles.includes(userRole);
}

function setup(router, vue) {
  _router = router;
  _vue = vue;
}

function sessionExpired() {
  _router.push({ name: 'Logout' });
  _vue.prototype.$error('Your session has expired. Please log in again.');
}

export {
  checkAuth,
  roles,
  setup,
  sessionExpired,
};
